import { render, staticRenderFns } from "./RegulatedProfessionsModal.vue?vue&type=template&id=1cad675e&scoped=true"
import script from "./RegulatedProfessionsModal.vue?vue&type=script&lang=ts"
export * from "./RegulatedProfessionsModal.vue?vue&type=script&lang=ts"
import style0 from "./RegulatedProfessionsModal.vue?vue&type=style&index=0&id=1cad675e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cad675e",
  null
  
)

export default component.exports